<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center rounded-md bg-steel-100"
  >
    <img
      src="@/assets/light-yellow-spinner.svg"
      alt="searching lane"
      class="spinner mb-4"
    />
    <h1 class="text-selected-tab-text mb-1 text-lg">Loading...</h1>
  </div>
</template>

<style scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner {
  animation: spin 1.5s linear infinite;
}
</style>
